import { useMutation, useQueryClient } from "@tanstack/react-query";

import { $api, fetchClient, invalidate } from "./client";
import type { components } from "./schema";

export type Configuration = components["schemas"]["Configuration"];
export type PatchedConfiguration =
  components["schemas"]["PatchedConfigurationRequest"];

/** GET /api/v1/configuration/ — the per-tenant singleton; rarely changes mid-session. */
export function useConfiguration() {
  return $api.useQuery("get", "/api/v1/configuration/", undefined, {
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateConfiguration() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (patch: PatchedConfiguration) =>
      (await fetchClient.PATCH("/api/v1/configuration/", { body: patch }))
        .data!,
    onSuccess: () => invalidate(queryClient, "/api/v1/configuration/"),
  });
}
